import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { LOGO_URL } from "@/lib/api";
import { XCircle, RefreshCw } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    axios
      .get(`${BASE}/api/payments/status/${sessionId}`)
      .then((r) => setStatus(r.data))
      .catch(() => setStatus({ payment_status: "unknown" }));
  }, [sessionId]);

  const failed = status?.payment_status === "failed";

  return (
    <div data-testid="payment-cancel-root" className="min-h-screen bg-stone-50 flex items-center justify-center p-8">
      <div className="ns-card max-w-lg w-full p-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <img src={LOGO_URL} alt="" className="w-10 h-10 rounded-lg" />
          <div className="ns-label">Newport Stays</div>
        </div>
        {failed ? (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 data-testid="payment-failed-title" className="font-serif text-3xl mt-6">
              Payment failed — try again
            </h1>
            <p className="mt-3 text-slate-500 text-sm">
              Your bank declined the payment. No money left your account. Give it another try with a different card,
              or drop us a line at{" "}
              <a href="mailto:hello@newportstays.co.uk" className="text-teal-700 underline">
                hello@newportstays.co.uk
              </a>
              .
            </p>
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
            <h1 className="font-serif text-3xl mt-6">No worries — nothing charged.</h1>
            <p className="mt-3 text-slate-500 text-sm">
              Your card wasn't charged. If you changed your mind about the dates, head back and pick different ones.
            </p>
          </>
        )}
        <button
          onClick={() => window.history.back()}
          className="mt-8 inline-flex items-center gap-2 rounded-full ns-btn-primary text-white text-sm px-5 py-2.5"
        >
          <RefreshCw className="w-4 h-4" /> Try again
        </button>
        <div className="mt-6 text-[11px] tracking-widest uppercase text-slate-400">
          <Link to="/">Back to Newport Stays</Link>
        </div>
      </div>
    </div>
  );
}
